import React, { Component } from 'react';

import AllPeeps from '../SVG/AllPeeps';

export default class MetricsFlashItem extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    render() {

        let icon = this.props.icon;
        if (this.props.icon === 'all_peeps') {
            icon = <AllPeeps className="metrics-flash-item-icon-allpeeps" />
        }

        return (
            <div className="metrics-flash-item-outer" onClick={this.props.onClick === undefined ? null : this.props.onClick}>
                <div className="metrics-flash-item-icon material-icons">{icon}</div>
                <div className="metrics-flash-item-text">{this.props.text}</div>
                <div className="metrics-flash-item-add">{this.props.add}</div>
            </div>
        );
    }
}